import * as ActionTypes from './actionTypes';
import _ from 'lodash';

const initState = {
  data: [],
  defaultDropdownOptions: {
    uniqueNeighborhood: [],
    uniqueDocumentTypes: [],
    uniqueProjectNames: []
  },
  filters: {
    docTypeValue: '',
    neighborhoodValue: '',
    projId: '',
    startDate: "2015-01-01T23:59:59.000Z",
    endDate: new Date().toISOString(),
    searchText: '',
    page: 1,
    pageMarker: {}
  },
  totalDocCount: "",
  isFiltering: false,
  isFilteredData: false,
  pageChange: false,
  showProgress: true,
  allWebURL: [],
};
export default function reducer(state = initState, action) {
  if (typeof state === 'undefined') {
    return initState;
  }

  switch (action.type) {
    case ActionTypes.UPDATE_DATA:
      return {
        ...state,
        data: action.data,
        isFilteredData: false,
        pageChange: false,
        showProgress: false
      };

    case ActionTypes.FILTER_DATA:
      return {
        ...state,
        filters: action.filters,
        page: action.filters.page,
        isFilteredData: true,
        showProgress: true
      };

    
    case ActionTypes.DEFAULT_FILTERS:
      return {
        ...state,
        defaultDropdownOptions: action.defaultDropdownOptions,
        isFilteredData: false
      };

    case ActionTypes.PAGE_CHANGE:
      return {
        ...state,
        filters: {
          ...state.filters,
          page: action.page
        },
        pageChange: true
      };

    case ActionTypes.TOTAL_DOC_COUNT:
      return {
        ...state,
        totalDocCount: action.totalDocCount
      };
    case ActionTypes.UPDATE_FILTER_FIELD:
      if (_.isEqual(state.filters[action.field], action.value)) {
        return state; // there is no change so return the same state
      }

      return {
        ...state,
        filters: {
          ...state.filters,
          [action.field]: action.value,
        }
      };

    case ActionTypes.GET_WEBSITE_URLS:
      return {
        ...state,
        allWebURL: action.allWebURL
      };

    default:
      return state;
  }
}
